import {
  AlertCircle,
  Bookmark,
  Building2,
  Filter,
  Flag,
  Heart,
  Mail,
  Shield,
  Star,
  Tag,
  Users,
  Wrench,
  Zap,
  Eye,
  Clock,
  Inbox,
  type LucideIcon,
} from 'lucide-react'

export type SavedViewIconKey =
  | 'bookmark'
  | 'star'
  | 'users'
  | 'building'
  | 'filter'
  | 'tag'
  | 'shield'
  | 'wrench'
  | 'mail'
  | 'alert'
  | 'flag'
  | 'heart'
  | 'zap'
  | 'eye'
  | 'clock'
  | 'inbox'

export const SAVED_VIEW_ICONS: {
  key: SavedViewIconKey
  label: string
  Icon: LucideIcon
}[] = [
  { key: 'bookmark', label: 'Bookmark', Icon: Bookmark },
  { key: 'star', label: 'Star', Icon: Star },
  { key: 'users', label: 'Users', Icon: Users },
  { key: 'building', label: 'Building', Icon: Building2 },
  { key: 'filter', label: 'Filter', Icon: Filter },
  { key: 'tag', label: 'Tag', Icon: Tag },
  { key: 'shield', label: 'Shield', Icon: Shield },
  { key: 'wrench', label: 'Wrench', Icon: Wrench },
  { key: 'mail', label: 'Mail', Icon: Mail },
  { key: 'alert', label: 'Alert', Icon: AlertCircle },
  { key: 'flag', label: 'Flag', Icon: Flag },
  { key: 'heart', label: 'Heart', Icon: Heart },
  { key: 'zap', label: 'Zap', Icon: Zap },
  { key: 'eye', label: 'Eye', Icon: Eye },
  { key: 'clock', label: 'Clock', Icon: Clock },
  { key: 'inbox', label: 'Inbox', Icon: Inbox },
]

const ICON_MAP = Object.fromEntries(
  SAVED_VIEW_ICONS.map((i) => [i.key, i.Icon]),
) as Record<SavedViewIconKey, LucideIcon>

export function getSavedViewIcon(key: string | null | undefined): LucideIcon {
  if (key && key in ICON_MAP) return ICON_MAP[key as SavedViewIconKey]
  return Bookmark
}

export function isSavedViewIconKey(key: string): key is SavedViewIconKey {
  return key in ICON_MAP
}
